import styled from 'styled-components';

export const Container = styled('div')`
  margin: 0 auto;
  padding: 0 24px;
  max-width: 1280px;
`;
